import Vue from 'vue'
import ToolbarExtras from '@/components/ToolbarExtras'

/**
 * listToolbarExtras — 全局 mixin
 * 在 mounted 后扫描当前组件根节点的 .krj-toolbar：
 *   - 若不存在则直接返回（不污染非列表页）；
 *   - 若存在则把 ToolbarExtras（隐藏/显示搜索 + 刷新）注入到 .krj-toolbar，
 *     由 CSS Grid 布局自动排到「第二行右侧」；业务操作按钮 (.krj-toolbar__actions)
 *     落在「第二行左侧」，两者同一行、左右分居。
 *
 * 切换按钮显隐：统计 .krj-searchbar 内的 .el-form-item 数量，
 *   有搜索项 → 显示「隐藏/显示搜索」；无搜索项 → 仅显示「刷新」。
 *
 * 刷新策略：优先调用 this.getList()（30+ 列表页通用方法名），
 *           缺省时回退到 $emit('refresh')，
 *           最后兜底触发 .krj-searchbar 内的「查询」按钮 click。
 * 隐藏/显示搜索：直接切换 .krj-searchbar 的 display。
 */
export default {
  data() {
    return {
      __krjExtrasInstance: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.__krjInstallExtras()
    })
  },
  beforeDestroy() {
    if (this.__krjExtrasInstance) {
      const el = this.__krjExtrasInstance.$el
      this.__krjExtrasInstance.$destroy()
      if (el && el.parentNode) el.parentNode.removeChild(el)
      this.__krjExtrasInstance = null
    }
  },
  methods: {
    __krjInstallExtras() {
      const root = this.$el
      if (!root || typeof root.querySelector !== 'function') return
      // opt-out：页面根节点加 class="no-krj-extras" 可跳过注入
      if (root.classList && root.classList.contains('no-krj-extras')) return

      const toolbar = root.querySelector('.krj-toolbar')
      if (!toolbar) return
      // 防重复注入（HMR / 重复挂载）
      if (toolbar.querySelector('.krj-toolbar__extras')) return

      // 是否含有搜索项：决定「隐藏/显示搜索」按钮的显隐
      const searchbar = toolbar.querySelector('.krj-searchbar')
      const hasSearchFields = !!searchbar && searchbar.querySelectorAll('.el-form-item').length > 0

      const ExtrasCtor = Vue.extend(ToolbarExtras)
      const instance = new ExtrasCtor({
        propsData: {
          showToggle: hasSearchFields
        }
      })

      // 隐藏/显示搜索：仅切换 .krj-searchbar 的显示，
      // 组件自身维护 searchVisible 状态（点击即翻转），父级无需回写。
      instance.$on('toggle-search', (val) => {
        if (searchbar) {
          searchbar.style.display = val ? '' : 'none'
        }
      })

      // 刷新：调用页面 getList()；无论成功/失败都复位 loading，避免按钮卡死。
      instance.$on('refresh', () => {
        this.__krjHandleRefresh(instance)
      })

      instance.$mount()
      toolbar.appendChild(instance.$el)
      this.__krjExtrasInstance = instance
    },

    __krjHandleRefresh(instance) {
      const finish = () => {
        if (instance) instance.loading = false
      }
      try {
        // 1) 标准方法
        if (typeof this.getList === 'function') {
          const ret = this.getList()
          if (ret && typeof ret.then === 'function') {
            ret.then(finish).catch(finish)
          } else {
            finish()
          }
          return
        }
        // 2) 监听 refresh 事件
        if (this.$listeners && this.$listeners.refresh) {
          this.$emit('refresh')
          finish()
          return
        }
        // 3) 兜底：触发 SearchBar 的「查询」按钮
        const primaryBtn = this.$el && this.$el.querySelector('.krj-searchbar .el-button--primary')
        if (primaryBtn) primaryBtn.click()
        finish()
      } catch (e) {
        finish()
        throw e
      }
    }
  }
}
